import type { StandardReportIdentityInterface } from '@nts/std/interfaces';
import { GeneratedStandardReportIdentity } from './generated-standard-report.identity';

export class StandardReportIdentity extends GeneratedStandardReportIdentity implements StandardReportIdentityInterface {
}
